import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Rollbar from 'vue-rollbar'
import PortalVue from 'portal-vue'
import { pinia } from 'Store'
import registerDirective from './Directive'
import i18n from 'src/javascript/i18n'
import TModal from 'javascript/Common/TModal'
import TSpinner from 'javascript/Common/TSpinner'
import ThemeButton from 'javascript/Common/ThemeButton'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'
import Root from './Root'
import TSwitch from 'javascript/Common/TSwitch'
// import { gbInstance } from 'javascript/growthbook'

const ROLLBAR_IGNORED_MESSAGES = [
  '.*Security Policy Violation: blockedURI.*',
  '.*Blocked a frame with origin.*'
]

Vue.use(Vuelidate)
Vue.use(PortalVue)
Vue.use(Rollbar, {
  accessToken: process.env.ROLLBAR_TOKEN,
  captureUncaught: false,
  captureUnhandledRejections: false,
  enabled: process.env.NODE_ENV === 'production' || TARGET_ENV === 'qa' || TARGET_ENV === 'staging',
  environment: TARGET_ENV,
  autoInstrument: false,
  captureIp: false,
  ignoredMessages: ROLLBAR_IGNORED_MESSAGES,
  payload: {
    person: {
      id: triplaLocalStorage.getItem('triplabot_user_id')
    },
    client: {
      javascript: {
        code_version: COMMIT_HASH,
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
})

Vue.component('t-modal', TModal)
Vue.component('t-spinner', TSpinner)
Vue.component('t-button', ThemeButton)
Vue.component('t-switch', TSwitch)

// Vue.prototype.$gb = gbInstance

registerDirective()

// if (process.env.NODE_ENV === 'production') {
// Vue.config.errorHandler = (err, vm, info) => {
// err: error trace
// vm: component in which error occured
// info: Vue specific error information such as lifecycle hooks, events etc.
// Vue.rollbar.error(err, info)
// console.error(err)
// }

// TODO: find a way to check error from CB only, maybe check source is from our tripla.min.js
// window.onerror = function (message, source, lineno, colno, error) {
//   Vue.rollbar.error(
//     `Error: ${error}\nMessage: ${message}\nSource: ${source}, line:${lineno}, column:${colno}`
//   )
// }
// }

export default function (scriptConfig, triplabotSettings, appID) {
  new Vue({
    pinia,
    i18n,
    el: '#' + appID,
    provide: {
      scriptConfig
    },
    render: (h) =>
      h(Root, {
        attrs: {
          id: appID
        },
        props: {
          scriptConfig,
          triplabotSettings
        }
      })
  })
}
